import { render, staticRenderFns } from "./detail_change_state_page.vue?vue&type=template&id=798bc0e2&scoped=true"
import script from "./detail_change_state_page.vue?vue&type=script&lang=js"
export * from "./detail_change_state_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798bc0e2",
  null
  
)

export default component.exports